import { withClassName } from "../../../utils/reactHelpers/withClassName"

export const PrefixText = withClassName("text-gray-400", "div")
